import { Skeleton } from '@mui/material';
import { FC } from 'react';

const SkeletonLoader: FC<React.PropsWithChildren<SkeletonLoaderProps>> = ({
  loading,
  children,
  message,
}) => {
  if (loading) {
    return (
      <Skeleton
        variant='rectangular'
        width='100%'
        height='100%'
        sx={{
          borderRadius: '10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
        }}>
        {message}
      </Skeleton>
    );
  }
  return <>{children}</>;
};

interface SkeletonLoaderProps {
  loading: boolean;
  message?: string;
}

export default SkeletonLoader;
